export default "__VITE_ASSET__BRTbSENn__"